import { render, staticRenderFns } from "./SpecsModal.vue?vue&type=template&id=134fa39c&scoped=true&"
import script from "./SpecsModal.vue?vue&type=script&lang=ts&"
export * from "./SpecsModal.vue?vue&type=script&lang=ts&"
import style0 from "./SpecsModal.vue?vue&type=style&index=0&id=134fa39c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134fa39c",
  null
  
)

export default component.exports